import axios from "axios";
import Constants from "../../../components.constants.js"

export default {
    async getAllJobsFromServer(context, payload = {}) {

        try {
            let resp = await axios.get(Constants.jobsUrl, payload);
            if (resp.status == 200) {
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[getAllFilesFromServer][Store][Error occured while getting fileslist--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("users/logOutFromServer", {}, { root: true })
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },

    async getAllJobsStatusFromServer(context, payload = {}) {

        try {
            let resp = await axios.get(`${Constants.jobsUrl}` + "/status/options", payload);
            if (resp.status == 200) {
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[getAllJobsStatusFromServer][Store][Error occured while getting fileslist--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("users/logOutFromServer", {}, { root: true })
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },

    async getJobInfoFromServer(context, payload = {}) {
        //payload : {params:{jobId:"3422344231"}}

        try {
            let jobId = payload.params.jobId
            delete payload.params.jobId
            let resp = await axios.get(`${Constants.jobsUrl}/${jobId}`, payload);
            if (resp.status == 200) {
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[getFileInfoFromServer][Store][Error occured while getting file info--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("users/logOutFromServer", {}, { root: true })
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },
    async updateJobInfo(context, payload = {}) {
        //payload : {params:{fileId:"3422344231"}}

        try {
            let resp = await axios.put(`${Constants.jobsUrl}/${payload.params.fileId}`, payload);
            if (resp.status == 200) {
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[updateFileInfo][Store][Error occured while getting file info--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("users/logOutFromServer", {}, { root: true })
                } else if (error.response.status == 405) {
                    return { statusCode: error.response.status, message: "failed to update file info" }
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },
    async updateJobPriority(context, payload = {}) {
        //payload : {params:{jobId:"3422344231"}}

        try {
            let resp = await axios.put(`${Constants.jobsUrl}/${payload.params.jobId}` + "/priority", payload);
            if (resp.status == 200) {
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[updateJobPriority][Store][Error occured on priority change of job--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("users/logOutFromServer", {}, { root: true })
                } else if (error.response.status == 405) {
                    return { statusCode: error.response.status, message: "failed to update file info" }
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },
    async retryfailedJob(context, payload = {}) {
        //payload : {params:{jobId:"3422344231"}}

        try {
            let resp = await axios.put(`${Constants.jobsUrl}/${payload.params.jobId}` + "/retry");
            if (resp.status == 200) {
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[retryfailedJob][Store][Error occured on retry of job--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("users/logOutFromServer", {}, { root: true })
                } else if (error.response.status == 405) {
                    return { statusCode: error.response.status, message: "failed to update file info" }
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },

    async createNewJob(context, payload = {}) {
        try {
            let resp = await axios.post(Constants.jobsUrl, payload);
            if (Constants.acceptedStatusCodes.includes(resp.status)) {
                console.log(
                    `[createNewJob][Store][Job post resp-->${resp.status}]`
                );
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[createNewJob][Store][Error occured while Posting job--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("users/logOutFromServer", {}, { root: true })
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    }
};